import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppConstants } from 'src/app/models/AppConstants';
import { EmployeeDto } from 'src/app/models/EmployeeDto';
import { NotificationType } from 'src/app/models/notification.message';
import { DocumentModel } from 'src/app/models/requests/DocumentUploadDto';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { DocumentsService } from 'src/app/services/documents.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { DatePipe } from '@angular/common';



@Component({
  selector: 'app-emp-inductions',
  templateUrl: './emp-inductions.component.html',
  styleUrls: ['./emp-inductions.component.css']
})
export class EmpInductionsComponent implements OnInit {

  contextMenu($event: MouseEvent, menu: NzDropdownMenuComponent, data:any): void {

    
    this.nzContextMenuService.create($event, menu);
    this.UpdateEmployee = data;
  }

  constructor(private datepipe: DatePipe,   private nzContextMenuService: NzContextMenuService,  private documentService: DocumentsService, private employeeService: EmployeesService, private tokenService: TokenService, private router: Router,
    private notification: NotificationService) { }

 
 
   biometricUpdateTitle='Biometric Info Update';
    items: MenuItem[] = [];
    terminationComment=''
    terminationDate:Date = new Date();
    isTerminationVisible:boolean=false;
  bioOfficerName: string = '';
  datecaptured:Date = new Date();
  biometricenddate: Date = new Date();
  biometricstartdate: Date = new Date();
  Employees: EmployeeDto[] = [];
  ViewEmployeeVisible: boolean = false;
  UpdateEmployee: any;
  public searchText: string = '';
  loading: boolean = true;
  userRole: string = ''
  edit: boolean = false
  updateButtonVisible: boolean = false
  safetyOption: boolean = false;
  biometricOption: boolean = false;

  safetyStatus: boolean = false;
  biometricStatus: boolean = false;
  safetyOfficer: string = ''
  safetyInductionDate:Date = new Date();
  size: number = 0;
  Documents: DocumentModel[] = [];
  isChangeOkLoading = false;
  isSafetyVisible:boolean =false;
  isBiometricModalVisible:boolean=false;
safetyTitle:string="Safety Info Update";
terminateTitle:string='Terminate Employee : ';

  ngOnInit(): void {
    this.loadRecords();
    this.getUserData();
    this.loading = false;

    this.buildContextMenus()
    { }
  }
  openSideView()
  {
    this.open(this.UpdateEmployee);
  }
  openBiometricCapture(){
    
    let date = new Date();
    date = this.UpdateEmployee.endDate;
    let strDate = this.transformDate(date); 
    

this.isBiometricModalVisible=true;
this.biometricUpdateTitle="Biometric Info Update for : " + this.UpdateEmployee.firstName+ " "+ this.UpdateEmployee.lastName +   '<br/>' +"End Date: "+strDate;
this.bioOfficerName =  this.UpdateEmployee.bioOfficerName;


  }
  transformDate(date: Date) {
    var dd = this.datepipe.transform(date, 'yyyy-MM-dd');
    
    return dd;
  }
  openTerminate(){
this.isTerminationVisible = true;
this.terminateTitle ="Terminate Employee: " + this.UpdateEmployee.firstName;


  }
  openSafetyCapture(){
    
    this.isSafetyVisible=true;
    this.safetyOfficer = this.UpdateEmployee.safetyInductionDoneBy;
  //  this.safetyInductionDate = this.UpdateEmployee.safetyInductiondate;
    this.safetyStatus = this.UpdateEmployee.isSafetyInductionDone;

    var date:Date = this.UpdateEmployee.safetyInductiondate;
     var datestring=this.datepipe.transform(date, 'MM/dd/yyyy');
    let date1: Date = new Date(datestring!);  
    this.safetyInductionDate = date1;
    
    this.safetyTitle = 'Update Safety Info for : ' + this.UpdateEmployee.firstName;
      }
    
     

  buildContextMenus() {
    this.items = [
      { label: 'View', icon: 'pi pi-fw pi-search', command: () => this.open(this.UpdateEmployee) },
      //    {label: 'Delete', icon: 'pi pi-fw pi-times', command: () => this.deleteProduct(this.selectedProduct)}
    ];
  }
  async loadRecords() {
    
    let resEmployees = await this.employeeService.getEmpsforBiometricUpdate().toPromise();   //getEmpsforBiometricUpdate().toPromise();
    this.Employees = <EmployeeDto[]>resEmployees.responseData;
    this.size = this.Employees.length;
 
  }

  getStatusColor(status: boolean): string {
    if (status) {
      return 'user-active';
    }
    else { return 'user-not-active' }

  }
  handleCancel(): void {
 
    this.isBiometricModalVisible = false;
  }
  handleCancel2(): void {
 
    this.isSafetyVisible = false;
  }
  handleCancel3(): void {
 
    this.isTerminationVisible = false;
  }
  async open(data: EmployeeDto) {

    
    this.UpdateEmployee = data;
    this.safetyStatus = data.isSafetyInductionDone;
    this.biometricStatus = data.isBiometricCaptured;
    this.ViewEmployeeVisible = true;
    this.bioOfficerName = '';

    let docs = await this.documentService.getDocumentsByEmployee(data.id).toPromise();
    this.Documents = <DocumentModel[]>docs.responseData;

  }

  close(): void {
    this.ViewEmployeeVisible = false;
    this.edit = false
    this.getUserData();
  }

  getUserData(): void {

    try {

   
      const userData: LoginResponseData = this.tokenService.getInfo();
      this.userRole = userData.profile.roleName;
      var UserPermission = userData.permission;

      const BiometricPerm = UserPermission.find((obj) => {
        return obj.permissionName === "Biometric";
      });

      if (BiometricPerm) {
        if (BiometricPerm.canAdd) {
          this.biometricOption = true;
       //   this.updateButtonVisible = true

        }

      }

      /*    if (this.userRole === "Biometric officer") {
            this.biometricOption = true;
            this.updateButtonVisible = true
          }
    */
      const SafetyPerm = UserPermission.find((obj) => {
        return obj.permissionName === "Safety";
      });

      if (SafetyPerm) {
        if (SafetyPerm.canAdd) {
          this.safetyOption = true
          this.updateButtonVisible = true
          this.safetyOfficer = userData.fullNamme

        }

      }

      /*      if (this.userRole === "Safety Officer") {
              this.safetyOption = true
              this.updateButtonVisible = true
              this.safetyOfficer = userData.fullNamme
            }*/

    }
    catch (e: unknown) { }


  }

  updateBiometrics() {
    const data =
    {

      id: this.UpdateEmployee.id,
      captured: this.biometricStatus,
      datecaptured: this.datecaptured,
      bioOfficerName: this.bioOfficerName,
      biometricEndDate: this.biometricenddate,
      biometricStartDate: this.biometricstartdate
    }
    if (data.bioOfficerName.length==0) {
      this.notification.sendMessage({
        message: 'Biometric officer is required',
        type: NotificationType.error
      });
     return;
    }
    this.employeeService.updateBiometrics(data).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });
          this.loadRecords()
          this.close()
          this.handleCancel();;
          this.handleCancel2();
          this.handleCancel3();

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }


  onChangeInductionDate(result: Date): void {

    if (result) {
      this.safetyInductionDate = result;
     
    }

  }
  onChangeTerminationDate(result: Date): void
  {
this.terminationDate = result;


  }
  updateSafety() {
    const data =
    {
      id: this.UpdateEmployee.id,
      safetyDone: this.safetyStatus,
      safetyInductionDate: this.safetyInductionDate,
      safetyOfficerName: this.safetyOfficer
    }

    this.employeeService.updateSafety(data).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });
          this.loadRecords()
          this.isSafetyVisible = false;
          this.close()
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  beginEdit() { this.edit = true, this.updateButtonVisible = false }

  openDocuments() {
    
    var id = this.UpdateEmployee.id;
    this.router.navigate(['/employeedocuments'], { queryParams: { id } });

  }

  terminateEmployeeUpdate() {
    const data =
    {
      empId: this.UpdateEmployee.id,
      message: this.terminationComment,
      enddate: this.terminationDate,
     
    }

    this.employeeService.TerminateEmployee(data).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });
          this.loadRecords()
          this.isTerminationVisible = false;
          this.close()
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
